export default function registerFilters(Vue) {
    const formatNumericString = (value, places) => {
        if (value === null || value === undefined) return "";

        let str = value.toString().replace(/\D/g, "");
        if (str === "") return "";

        if (places > 0 && str.length < places) {
            str = str.padStart(places, "0");
        }

        if (str.length > 3) {
            str = str.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }

        return str;
    };

    /** Contagens, estoque, totais — sem zeros à esquerda (ex.: 99, não 000.099). */
    Vue.filter("count", function (value) {
        return formatNumericString(value, 0);
    });

    /** SKU — padding fixo de 6 dígitos (legado ERP). */
    Vue.filter("sku", function (value) {
        return formatNumericString(value, 6);
    });

    Vue.filter("integer", function (value, places = 6) {
        return formatNumericString(value, places);
    });

    Vue.filter(
        "decimal",
        function (value, places = 2, decimalSep = ",", thousandSep = null) {
            if (value === null) return "";
            if (thousandSep === null) {
                thousandSep = decimalSep === "," ? "." : ",";
            }

            const num = parseFloat(value);
            let str;
            if (isNaN(num)) return "";

            if (places === 0) {
                str = Math.round(num).toString();
            } else {
                str = num.toFixed(places).replace(".", decimalSep);
            }

            // Divide integer and fractional parts
            let [integer, fraction] = str.split(decimalSep);

            integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);

            return places === 0
                ? integer
                : integer + decimalSep + (fraction || "");
        }
    );

    Vue.filter("date", function (value, mask = "DD/MM/YYYY") {
        return value ? moment(value).format(mask) : "-";
    });

    Vue.filter("month", function (value, mask = "MM/YYYY") {
        return value ? moment(value).format(mask) : "-";
    });

    Vue.filter("time", function (value) {
        return value ? moment(value).format("HH:mm") : "-";
    });

    Vue.filter("datetime", function (value) {
        return value ? moment(value).format("DD/MM/YYYY HH:mm") : "-";
    });

    Vue.filter("quantidade", function (value, step) {
        if (step == 1) {
            return parseFloat(value)
                .toFixed(0)
                .replace(".", ",")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
        return parseFloat(value)
            .toFixed(3)
            .replace(".", ",")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    });

    Vue.filter("cpf", function (cpf) {
        if (cpf === null || cpf === undefined || isNaN(cpf)) return "";
        return cpf.replace(
            /^(\d{3})\D*(\d{3})\D*(\d{3})\D*(\d{2})$/g,
            "$1.$2.$3-$4"
        );
    });

    Vue.filter("cnpj", function (cnpj) {
        if (cnpj === null || cnpj === undefined || cnpj === "") return "";
        if (typeof window.formatCnpj === "function") {
            var formatted = window.formatCnpj(cnpj);
            if (formatted) {
                return formatted;
            }
        }
        var raw = String(cnpj).toUpperCase().replace(/[.\-\/\s]/g, "");
        if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(raw)) {
            return String(cnpj);
        }
        return (
            raw.substring(0, 2) + "." +
            raw.substring(2, 5) + "." +
            raw.substring(5, 8) + "/" +
            raw.substring(8, 12) + "-" +
            raw.substring(12, 14)
        );
    });
}
